<template>
	<div>
        <h3>Galerija</h3>
		<LightGallery :images="galleryItems" :index="index" :disable-scroll="true" @close="index = null"/>
        <div class="ui six column grid">
            <div class="column" v-for="(item, i) in galleryItems" :key="i" @click="index = i">
                <div class="ui segment">
                    <img class="thumb" :src="item.url">
                </div>
            </div>
        </div>
	</div>
</template>

<script>
import { LightGallery } from 'vue-light-gallery'

export default {
	components: {
        LightGallery
    },
    props: ['data'],
	data() {
		return {
            index: null
		};
	},
	mounted() {
	},
	methods: {
        
	},
    filters: {
        
	},
	computed: {
		galleryItems() {
            return this.data.map(item => {
                return {
                    url: item.image,
                    title: item.caption
                }
            })
        }
	}
};
</script>

<style lang="scss" scoped>

    .thumb {
        width: 100%;
        height: auto;
        padding: 0;
        cursor: pointer;
    }

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/NewsGallery.vue